import { getAuthHeaders } from "../utils/servicesUtils";
import { apiFetch } from "../utils/apiFetch";

export const getAccessScopeService = async () => {
  const response = await apiFetch("/api/dashboard/access-scope/", {
    method: "GET",
    headers: getAuthHeaders(),
    credentials: "include",
  });

  if (!response.ok) {
    let errorData = null;
    try {
      errorData = await response.json();
    } catch (e) {}
    throw new Error(errorData?.message || "Failed to load access scope");
  }

  return response.json();
};

export const searchGlobalService = async (payload) => {
  const response = await apiFetch("/api/dashboard/search/", {
    method: "POST",
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(payload || {}),
  });

  if (!response.ok) {
    let errorData = null;
    try {
      errorData = await response.json();
    } catch (e) {}
    throw new Error(errorData?.message || "Failed to search");
  }

  return response.json();
};
